import { useState } from "react";
import { Plus, Trash2, Save, X } from "lucide-react";
import { adminApi } from "../../api";
import PrecarioProdutoLookup from "./PrecarioProdutoLookup";

const CATEGORIAS = [
  { value: "CURSO", label: "Curso (isento IVA)", isento: "S" },
  { value: "PALESTRA", label: "Palestra", isento: "N" },
  { value: "WORKSHOP", label: "Workshop", isento: "N" },
  { value: "CONSULTORIA", label: "Consultoria/Coaching", isento: "N" },
];
const TRAINERS = ["", "IHTP", "ADELINO"];

const blankItem = (ord) => ({
  categoria: "CURSO", codigo: "", descricao: "", duracao_texto: "", duracao_horas: "",
  trainer: "", id_produto: null, valor_unitario: 0, valor_com_iva: null, valor_sem_desconto: null,
  poupanca_cliente: null, min_turma: null, max_turma: null, receita_min: null, receita_max: null,
  isento_iva: "S", desconto_incluido_pct: null, notas: "", ordem: ord, activo: "S",
});

function ItemRowEdit({ idPrecario, ivaPct, item, onSaved, onCancel, onError }) {
  const [f, setF] = useState({
    ...item,
    duracao_horas: item.DuracaoHoras ?? item.duracao_horas ?? "",
    valor_unitario: item.ValorUnitario ?? item.valor_unitario ?? 0,
    valor_com_iva: item.ValorComIVA ?? item.valor_com_iva ?? "",
    valor_sem_desconto: item.ValorSemDesconto ?? item.valor_sem_desconto ?? "",
    poupanca_cliente: item.PoupancaCliente ?? item.poupanca_cliente ?? "",
    min_turma: item.MinTurma ?? item.min_turma ?? "",
    max_turma: item.MaxTurma ?? item.max_turma ?? "",
    receita_min: item.ReceitaMin ?? item.receita_min ?? "",
    receita_max: item.ReceitaMax ?? item.receita_max ?? "",
    desconto_incluido_pct: item.DescontoIncluidoPct ?? item.desconto_incluido_pct ?? "",
    isento_iva: item.IsentoIVA ?? item.isento_iva ?? "N",
    activo: item.Activo ?? item.activo ?? "S",
    ordem: item.Ordem ?? item.ordem ?? 0,
    categoria: item.Categoria ?? item.categoria ?? "CURSO",
    codigo: item.Codigo ?? item.codigo ?? "",
    descricao: item.Descricao ?? item.descricao ?? "",
    duracao_texto: item.DuracaoTexto ?? item.duracao_texto ?? "",
    trainer: item.Trainer ?? item.trainer ?? "",
    notas: item.Notas ?? item.notas ?? "",
    id_produto: item.ID_Produto ?? item.id_produto ?? null,
    descricaoProduto: item.DescricaoProduto || null,
  });
  const [busy, setBusy] = useState(false);

  const idItem = item.ID_PrecarioItem || null;
  const update = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const onCategoria = (v) => {
    const cfg = CATEGORIAS.find((c) => c.value === v);
    update("categoria", v);
    if (cfg) update("isento_iva", cfg.isento);
  };

  const onValorBase = (v) => {
    update("valor_unitario", v);
    // Auto-calc IVA quando aplicável
    if (f.isento_iva !== "S") {
      const num = parseFloat(v);
      if (!Number.isNaN(num)) update("valor_com_iva", (num * (1 + ivaPct / 100)).toFixed(2));
    }
  };

  const submit = async () => {
    setBusy(true);
    const payload = {
      categoria: f.categoria,
      codigo: f.codigo || null,
      descricao: f.descricao,
      duracao_texto: f.duracao_texto || null,
      duracao_horas: f.duracao_horas === "" ? null : Number(f.duracao_horas),
      trainer: f.trainer || null,
      id_produto: f.id_produto ? Number(f.id_produto) : null,
      valor_unitario: Number(f.valor_unitario),
      valor_com_iva: f.valor_com_iva === "" ? null : Number(f.valor_com_iva),
      valor_sem_desconto: f.valor_sem_desconto === "" ? null : Number(f.valor_sem_desconto),
      poupanca_cliente: f.poupanca_cliente === "" ? null : Number(f.poupanca_cliente),
      min_turma: f.min_turma === "" ? null : Number(f.min_turma),
      max_turma: f.max_turma === "" ? null : Number(f.max_turma),
      receita_min: f.receita_min === "" ? null : Number(f.receita_min),
      receita_max: f.receita_max === "" ? null : Number(f.receita_max),
      isento_iva: f.isento_iva,
      desconto_incluido_pct: f.desconto_incluido_pct === "" ? null : Number(f.desconto_incluido_pct),
      notas: f.notas || null,
      ordem: Number(f.ordem || 0),
      activo: f.activo,
    };
    try {
      if (idItem) await adminApi.precarioItemUpdate(idPrecario, idItem, payload);
      else await adminApi.precarioItemCreate(idPrecario, payload);
      onSaved?.();
    } catch (e) { onError?.(e.message); }
    finally { setBusy(false); }
  };

  return (
    <tr className="bg-amber-50/40 border-b-2 border-amber-200" data-testid={`precario-item-edit-${idItem || "new"}`}>
      <td colSpan={9} className="p-3">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-2 text-xs">
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Categoria</span>
            <select value={f.categoria} onChange={(e) => onCategoria(e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-categoria">
              {CATEGORIAS.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Código</span>
            <input value={f.codigo || ""} onChange={(e) => update("codigo", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1 font-mono" data-testid="item-edit-codigo" />
          </label>
          <label className="flex flex-col gap-0.5 md:col-span-3">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Descrição</span>
            <input value={f.descricao || ""} onChange={(e) => update("descricao", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-descricao" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Ordem</span>
            <input type="number" value={f.ordem ?? 0} onChange={(e) => update("ordem", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-ordem" />
          </label>

          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Duração (texto)</span>
            <input value={f.duracao_texto || ""} onChange={(e) => update("duracao_texto", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-duracao-texto" placeholder="ex: 3 dias - 21h" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Duração (h)</span>
            <input type="number" step="0.01" value={f.duracao_horas ?? ""} onChange={(e) => update("duracao_horas", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-duracao-h" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Trainer</span>
            <select value={f.trainer || ""} onChange={(e) => update("trainer", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-trainer">
              {TRAINERS.map((t) => <option key={t} value={t}>{t || "—"}</option>)}
            </select>
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Min turma</span>
            <input type="number" value={f.min_turma ?? ""} onChange={(e) => update("min_turma", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Max turma</span>
            <input type="number" value={f.max_turma ?? ""} onChange={(e) => update("max_turma", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Isento IVA</span>
            <select value={f.isento_iva || "N"} onChange={(e) => update("isento_iva", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" data-testid="item-edit-isento">
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </label>

          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Valor unit. (s/IVA)</span>
            <input type="number" step="0.01" value={f.valor_unitario ?? 0} onChange={(e) => onValorBase(e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1 tabular-nums" data-testid="item-edit-valor" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Valor c/IVA</span>
            <input type="number" step="0.01" value={f.valor_com_iva ?? ""} onChange={(e) => update("valor_com_iva", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1 tabular-nums" data-testid="item-edit-valor-iva" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Valor s/desconto</span>
            <input type="number" step="0.01" value={f.valor_sem_desconto ?? ""} onChange={(e) => update("valor_sem_desconto", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1 tabular-nums" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Poupança cliente</span>
            <input type="number" step="0.01" value={f.poupanca_cliente ?? ""} onChange={(e) => update("poupanca_cliente", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1 tabular-nums" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Desc. incl. %</span>
            <input type="number" step="0.01" value={f.desconto_incluido_pct ?? ""} onChange={(e) => update("desconto_incluido_pct", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1 tabular-nums" />
          </label>
          <label className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Activo</span>
            <select value={f.activo || "S"} onChange={(e) => update("activo", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1">
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </label>

          <div className="md:col-span-3">
            <PrecarioProdutoLookup
              currentId={f.id_produto}
              currentLabel={f.descricaoProduto}
              onPick={(prod) => {
                update("id_produto", prod ? prod.ID_Produto : null);
                setF((p) => ({ ...p, descricaoProduto: prod ? prod.Descricao : null }));
              }}
            />
          </div>

          <label className="flex flex-col gap-0.5 md:col-span-3">
            <span className="text-[10px] uppercase text-[#978D78] font-bold">Notas</span>
            <input value={f.notas || ""} onChange={(e) => update("notas", e.target.value)} className="border border-[#E6E1D6] rounded px-1.5 py-1" />
          </label>
        </div>
        <div className="flex items-center justify-end gap-2 mt-3">
          <button onClick={onCancel} className="inline-flex items-center gap-1 px-2.5 py-1 text-xs border border-[#E6E1D6] rounded hover:bg-[#FAF8F2]" data-testid="item-edit-cancel"><X size={12} /> Cancelar</button>
          <button onClick={submit} disabled={busy} className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-bold uppercase tracking-wider bg-[#0F1829] text-white rounded hover:bg-black disabled:opacity-40" data-testid="item-edit-save"><Save size={12} /> {busy ? "..." : "Guardar"}</button>
        </div>
      </td>
    </tr>
  );
}

const EUR = (v) => (v == null ? "—" : Number(v).toLocaleString("pt-PT", { style: "currency", currency: "EUR" }));

function ItemRowView({ item, onEdit, onDelete }) {
  return (
    <tr className="border-b border-[#F3F0E7] hover:bg-[#FAF8F2]" data-testid={`precario-item-${item.ID_PrecarioItem}`}>
      <td className="px-3 py-2 text-xs font-mono text-[#978D78]">{item.Categoria}</td>
      <td className="px-3 py-2 text-xs font-mono">{item.Codigo || "—"}</td>
      <td className="px-3 py-2">
        <div className="text-sm font-medium">{item.Descricao}</div>
        <div className="text-[11px] text-[#6B7280]">
          {item.DuracaoTexto || "—"}
          {item.Trainer && <span className="ml-1.5 px-1.5 py-0.5 text-[10px] bg-[#0F1829] text-white rounded">{item.Trainer}</span>}
          {item.IsentoIVA === "S" && <span className="ml-1.5 px-1.5 py-0.5 text-[10px] bg-blue-100 text-blue-700 rounded">Isento IVA</span>}
          {item.DescontoIncluidoPct ? <span className="ml-1.5 px-1.5 py-0.5 text-[10px] bg-amber-100 text-amber-800 rounded">Desc. {Number(item.DescontoIncluidoPct).toFixed(0)}% incl.</span> : null}
        </div>
      </td>
      <td className="px-3 py-2 text-xs" data-testid={`precario-item-produto-${item.ID_PrecarioItem}`}>
        {item.ID_Produto
          ? (
            <div>
              <span className="font-mono text-[#0F1829] font-semibold">#{item.ID_Produto}</span>
              {item.DescricaoProduto && <div className="text-[10px] text-[#6B7280] max-w-[160px] truncate" title={item.DescricaoProduto}>{item.DescricaoProduto}</div>}
            </div>
          )
          : <span className="text-[#978D78]">—</span>}
      </td>
      <td className="px-3 py-2 tabular-nums text-right">{EUR(item.ValorUnitario)}</td>
      <td className="px-3 py-2 tabular-nums text-right text-[#6B7280]">{EUR(item.ValorComIVA)}</td>
      <td className="px-3 py-2 text-xs text-[#6B7280] tabular-nums">
        {item.MinTurma != null && item.MaxTurma != null ? `${item.MinTurma}–${item.MaxTurma}` : "—"}
      </td>
      <td className="px-3 py-2">
        {item.Activo === "S"
          ? <span className="text-[10px] uppercase tracking-wider text-green-700">Activo</span>
          : <span className="text-[10px] uppercase tracking-wider text-[#978D78]">Inactivo</span>
        }
      </td>
      <td className="px-3 py-2 text-right space-x-1">
        <button onClick={onEdit} className="text-xs px-2 py-1 border border-[#E6E1D6] rounded hover:bg-[#FAF8F2]" data-testid={`item-edit-btn-${item.ID_PrecarioItem}`}>Editar</button>
        <button onClick={onDelete} className="text-xs px-2 py-1 border border-red-200 text-red-700 rounded hover:bg-red-50" data-testid={`item-delete-btn-${item.ID_PrecarioItem}`}><Trash2 size={11} className="inline" /></button>
      </td>
    </tr>
  );
}

export default function PrecarioItemsTable({ idPrecario, items, ivaPct, onChanged, onError }) {
  const [editingId, setEditingId] = useState(null);
  const [adding, setAdding] = useState(false);
  const [filter, setFilter] = useState("");

  const visible = items.filter((i) => !filter || (i.Categoria || "").toUpperCase() === filter);

  const onDel = async (id) => {
    if (!window.confirm("Inactivar este item?")) return;
    try {
      await adminApi.precarioItemDelete(idPrecario, id);
      onChanged?.();
    } catch (e) { onError?.(e.message); }
  };

  return (
    <div className="bg-white border border-[#E6E1D6] rounded-md overflow-hidden" data-testid="precario-items-table">
      <div className="px-4 py-2.5 border-b border-[#F3F0E7] bg-[#FAF8F2] flex items-center justify-between flex-wrap gap-2">
        <span className="text-[11px] uppercase tracking-[0.18em] text-[#978D78] font-bold">Items ({items.length})</span>
        <div className="flex items-center gap-2">
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="text-xs border border-[#E6E1D6] rounded px-2 py-1" data-testid="items-filter">
            <option value="">Todas as categorias</option>
            {CATEGORIAS.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
          <button onClick={() => { setAdding(true); setEditingId(null); }} className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-bold uppercase tracking-wider bg-[#0F1829] text-white rounded hover:bg-black" data-testid="item-add-btn">
            <Plus size={12} /> Novo item
          </button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-[0.12em] text-[#978D78]">
            <tr className="border-b border-[#F3F0E7]">
              <th className="px-3 py-2">Cat.</th>
              <th className="px-3 py-2">Código</th>
              <th className="px-3 py-2">Descrição</th>
              <th className="px-3 py-2">Produto</th>
              <th className="px-3 py-2 text-right">Valor s/IVA</th>
              <th className="px-3 py-2 text-right">Valor c/IVA</th>
              <th className="px-3 py-2">Turma</th>
              <th className="px-3 py-2">Estado</th>
              <th className="px-3 py-2 text-right">Acções</th>
            </tr>
          </thead>
          <tbody>
            {adding && (
              <ItemRowEdit
                idPrecario={idPrecario}
                ivaPct={ivaPct}
                item={blankItem(items.length + 1)}
                onSaved={() => { setAdding(false); onChanged?.(); }}
                onCancel={() => setAdding(false)}
                onError={onError}
              />
            )}
            {visible.map((item) => (
              editingId === item.ID_PrecarioItem
                ? <ItemRowEdit key={item.ID_PrecarioItem} idPrecario={idPrecario} ivaPct={ivaPct} item={item}
                    onSaved={() => { setEditingId(null); onChanged?.(); }}
                    onCancel={() => setEditingId(null)}
                    onError={onError} />
                : <ItemRowView key={item.ID_PrecarioItem} item={item}
                    onEdit={() => { setEditingId(item.ID_PrecarioItem); setAdding(false); }}
                    onDelete={() => onDel(item.ID_PrecarioItem)} />
            ))}
            {!visible.length && !adding && (
              <tr><td colSpan={9} className="px-3 py-6 text-center text-sm text-[#6B7280]">Sem items para mostrar.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
